<template>
  <div class="personal-center">
    <div class="page-width">
      <div class="personal-title">
        <h3>个人中心</h3>
      </div>
      <div class="personal-container">
        <div class="personal-left">
          <ul class="menu-list">
            <router-link tag="li" to="account" class="menu-item">账号设置</router-link>
            <router-link
              tag="li"
              to="loginInfomation"
              class="menu-item"
              v-trace-click="'n.3387.6057.0'"
            >我的登录信息</router-link>
            <router-link tag="li" to="myDevice" class="menu-item">我的设备</router-link>
            <router-link tag="li" to="jobCard" class="menu-item">我的工卡</router-link>
          </ul>
        </div>
        <div class="personal-right">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pathConfig from "@/config/requirePath";
export default {
  name: "app",
  data() {
    return {
      pathConfig
    };
  }
};
</script>

<style lang="scss" scoped>
.router-link-exact-active {
  color: #1989fa;
  background-color: rgba(243, 250, 255, 1);
}
.page-width {
  width: 1200px;
  flex: 1;
  padding: 30px 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  h1 {
    font-size: 24px;
  }
}
.personal-center {
  background-color: #f8f8f8;
  width: 100%;
  flex: 1;
  display: flex;
  .personal-title {
    width: 1200px;
    margin-bottom: 20px;
  }
  .personal-container {
    display: flex;
    flex: 1;
  }
  .personal-left {
    width: 200px;

    margin-right: 20px;
    background-color: #fff;
    .menu-list {
      .menu-item {
        padding: 18px 20px;
        cursor: pointer;
      }
    }
  }
  .personal-right {
    width: 980px;
    padding: 20px;
    background-color: #fff;
    overflow-y: auto;
  }
}
</style>
